// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx","739":"component---src-templates-content-tsx"}[chunkId] + "-" + {"245":"1d35ea7805f0da06da7e","453":"4efe0af7abf9bb36f663","739":"9f8d728049ece60ac608"}[chunkId] + ".js";
};